import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  return (
    <section className="py-10 sm:py-14 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden">
          <div className="grid lg:grid-cols-2">
            {/* Left — For Tenants */}
            <div className="p-8 lg:p-10">
              <span className="inline-block px-3 py-1 bg-rose-50 text-rose-600 text-xs font-semibold rounded-full mb-4">For Tenants</span>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Looking for a Rental?</h3>
              <ul className="space-y-3 mb-6">
                {[
                  'Browse verified owner listings',
                  'Chat directly with property owners',
                  'Schedule visits at your convenience',
                  'Pay rent securely through the platform',
                ].map((item, i) => (
                  <li key={i} className="flex items-start gap-2.5 text-sm text-gray-600">
                    <Icon name="Check" size={16} className="text-green-500 mt-0.5 shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
              <Link to="/advanced-search-discovery" className="inline-flex items-center gap-1.5 bg-rose-500 hover:bg-rose-600 text-white px-5 py-2.5 rounded-lg text-sm font-medium transition">
                Search Properties <Icon name="ArrowRight" size={16} />
              </Link>
            </div>

            {/* Right — For Owners */}
            <div className="p-8 lg:p-10 bg-gray-50 border-t lg:border-t-0 lg:border-l border-gray-200">
              <span className="inline-block px-3 py-1 bg-green-50 text-green-700 text-xs font-semibold rounded-full mb-4">For Owners</span>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Have a Property to Rent?</h3>
              <ul className="space-y-3 mb-6">
                {[
                  'List your property for free in minutes',
                  'Reach genuine tenants directly',
                  'Manage inquiries from your dashboard',
                  'Collect rent online with auto-receipts',
                ].map((item, i) => (
                  <li key={i} className="flex items-start gap-2.5 text-sm text-gray-600">
                    <Icon name="Check" size={16} className="text-green-500 mt-0.5 shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
              <Link to="/property-listing-creation" className="inline-flex items-center gap-1.5 bg-gray-900 hover:bg-gray-800 text-white px-5 py-2.5 rounded-lg text-sm font-medium transition">
                List Your Property <Icon name="ArrowRight" size={16} />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSignals;
